let routes = [
  {
    path: '/formulaire-soumis',
    name: 'FormulaireSoumis',
    component: () => import("../views/FormulaireSoumis.vue"),
    props: true
  },
  {
    path: '/formulaire-traite',
    name: 'FormulaireTraite',
    component: () => import("../views/FormulaireTraite.vue"),
    props: true
  },
  {
    path: '/question-preliminaire-permis-psychologue',
    component: () => import("../views/QuestionPreliminairePermisPsychologue.vue")
  },
  {
    path: '/admin/liens-formulaires',
    component: () => import("../views/Admin/Formulaires.vue")
  }
]

export default routes;


